module.exports = __webpack_public_path__ + "img/2_m.31dab639.jpg";